import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const BODY_CLASS = "text-[#6a6e6e] leading-[90%] text-sm font-normal font-['Matter']"
const TITLE_CLASS = "text-[#232323] text-sm font-medium font-['Matter'] leading-[21px]"

export const ReturnsBottomSheet = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Trailing Returns'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent
      logoSrc={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/trailing-returns-bottom-sheet.svg`}
      heading={heading}
      onDismiss={onDismiss}
    >
      <div className='flex flex-col gap-4'>
        <HelpDialogPassage accessibleLabel="Trailing returns measure the change in a mutual fund's value over a specified period.">
          <span className={BODY_CLASS}>
            Trailing returns measure the change in a mutual fund’s value over a specified period.
          </span>
        </HelpDialogPassage>
        <HelpDialogPassage accessibleLabel="For example, a 1Y trailing return of 10% means that the fund's value as of today is 10% higher than what it was a year ago.">
          <span className={BODY_CLASS}>
            For example, a 1Y trailing return of 10% means that the fund's value as of today is 10% higher than what it
            was a year ago.
          </span>
        </HelpDialogPassage>
        <HelpDialogPassage accessibleLabel="Pro Tip. Trailing returns are a point to point comparison, they don't account for any fluctuations in between. Hence, it may not capture the fund's consistency in giving good returns over a longer period of time.">
          <span className={TITLE_CLASS}>Pro Tip</span>
          <br />
          <span className={BODY_CLASS}>
            Trailing returns are a point to point comparison, they don’t account for any fluctuations in between. Hence,
            it may not capture the fund’s consistency in giving good returns over a longer period of time.
          </span>
        </HelpDialogPassage>
      </div>
    </BottomSheetContent>
  )
}
